import { FunctionComponent, useState } from "react";
import { DownoladXmlOne } from "../../../Services/AIListingCreation";
import { Popover, Button } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";


const DownoaldXmlPdf: FunctionComponent<{ onChangehandler: any }> = (props) => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const { t } = useTranslation();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDownload = () => {
        const obj = {
            "platform": [
                "Coralytics"
            ],
            "id": sessionStorage.getItem('propertyId')
        }
        DownoladXmlOne(obj).then((resp) => {
            const blob = new Blob([resp], { type: 'text/xml' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${"Property_" + obj.id}.xml`;
            a.click();
            URL.revokeObjectURL(url);
        }).catch((error) => {
            props.onChangehandler(error.response.data.message, true, "error")
        })
    }


    const HandlePDF = () => {
        window.open(`/create-property-report/${sessionStorage.getItem('propertyId')}`, '_blank');
    }

    return (<>
        <Box>
            <button
                aria-describedby={id}
                onClick={handleClick}
                className="button-reset back-746AFF color-FFFFFF marg-right-16 border-746AFF padd-15"
            >
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.3889 14H3.6111C2.78015 14 1.99889 13.6764 1.41124 13.0887C0.823616 12.5012 0.5 11.7199 0.5 10.8889V10.1111C0.5 9.68148 0.848205 9.33325 1.27778 9.33325C1.70736 9.33325 2.05556 9.68148 2.05556 10.1111V10.8889C2.05556 11.3044 2.21739 11.695 2.51114 11.9888C2.80498 12.2826 3.1956 12.4444 3.6111 12.4444H11.3889C11.8043 12.4444 12.195 12.2826 12.4888 11.9888C12.7826 11.6949 12.9444 11.3043 12.9444 10.8889V10.1111C12.9444 9.68148 13.2926 9.33325 13.7222 9.33325C14.1517 9.33325 14.5 9.68148 14.5 10.1111V10.8889C14.5 11.7198 14.1764 12.5011 13.5887 13.0887C13.0011 13.6764 12.2198 14 11.3889 14ZM7.49999 10.8888C7.39239 10.8888 7.28997 10.867 7.19677 10.8275C7.10983 10.7908 7.02813 10.7374 6.95665 10.6676C6.95662 10.6676 6.95662 10.6676 6.9566 10.6676C6.95608 10.6671 6.95556 10.6666 6.95505 10.6661C6.95491 10.6659 6.95475 10.6658 6.95461 10.6656C6.95418 10.6652 6.9538 10.6648 6.95339 10.6644C6.95312 10.6642 6.95287 10.6639 6.9526 10.6636C6.95233 10.6634 6.95198 10.663 6.95173 10.6628C6.95119 10.6622 6.95059 10.6617 6.95005 10.6611L3.83892 7.54995C3.53519 7.24622 3.53519 6.75375 3.83892 6.44999C4.14265 6.14627 4.63515 6.14624 4.93888 6.44999L6.72223 8.23335V0.777782C6.7222 0.348205 7.07041 0 7.49999 0C7.92956 0 8.2778 0.348205 8.2778 0.777782V8.23332L10.0611 6.44999C10.3648 6.14627 10.8574 6.14627 11.1611 6.44999C11.4648 6.75372 11.4648 7.24622 11.1611 7.54995L8.04995 10.6611C8.04941 10.6616 8.04881 10.6622 8.04827 10.6627C8.04797 10.663 8.04764 10.6634 8.0474 10.6636C8.04713 10.6639 8.04688 10.6641 8.04661 10.6644C8.04623 10.6648 8.04579 10.6652 8.04541 10.6656C8.04528 10.6657 8.04509 10.6659 8.04495 10.666C8.04446 10.6665 8.04395 10.667 8.04343 10.6675C8.0434 10.6675 8.0434 10.6675 8.04338 10.6676C8.03482 10.6759 8.02615 10.684 8.01729 10.6919C7.95217 10.75 7.87963 10.7953 7.80293 10.8276C7.80265 10.8277 7.80244 10.8278 7.80217 10.8279C7.80187 10.828 7.80162 10.8282 7.80132 10.8283C7.70862 10.8673 7.60684 10.8888 7.49999 10.8888Z" fill="white" />
                </svg>  {t("propertiesPage.download")}
            </button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                PaperProps={{
                    sx: {
                        padding: 0,
                        overflow: "visible",
                        background: "#FFFFFF",
                        borderRadius: "7px",
                        marginTop: "15px",
                        filter: "drop-shadow(0px 4px 48px rgba(0, 0, 0, 0.15))",
                    },
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        display: "flex",
                        backgroundColor: "white",
                        padding: "10px 5px",
                        borderRadius: "7px"
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "-10px",
                            left: "50%",
                            width: "0",
                            height: "0",
                            borderLeft: "10px solid transparent",
                            borderRight: "10px solid transparent",
                            borderBottom: "10px solid white",
                            transform: "translateX(-50%)",
                        }}
                    />
                    <Button
                        sx={{
                            background: "#FFFFFF",
                            border: "1px solid rgba(0, 0, 0, 0.2)",
                            borderRadius: "7px",
                            fontFamily: 'Plus Jakarta Sans',
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: "14px",
                            lineHeight: "18px",
                            color: "#000000 !important",
                            padding: "8px 16px",
                            margin: "0 10px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={handleDownload}
                    >
                        XML
                    </Button>
                    <Button
                        sx={{
                            background: "#FFFFFF",
                            border: "1px solid rgba(0, 0, 0, 0.2)",
                            borderRadius: "7px",
                            fontFamily: 'Plus Jakarta Sans',
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: "14px",
                            lineHeight: "18px",
                            color: "#000000 !important",
                            padding: "8px 16px",
                            margin: "0 10px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={HandlePDF}
                    >
                        PDF
                    </Button>
                </Box>
            </Popover >
        </Box >
    </>
    )
}
export default DownoaldXmlPdf;
